import Vue from 'vue';
import ElementUI from 'element-ui';
import BaiduMap from 'vue-baidu-map';
import echarts from 'echarts';
import App from './App';
import router from './router';
import store from '../../store/index';
import '../../utils/directive/display';
import { checkLogin, linkRedirect } from '../../utils/index';
import '../../../theme/index.css';
import '../../styles/base.less';
import 'babel-polyfill';
import utils from '@/utils/common';
import '../../utils/btnPermission';
import '../../utils/dragDialog.js';
import bigDataLog from '@/utils/bigDataLog';
import microApp from '@micro-zoe/micro-app';
import VXETable from 'vxe-table';
import 'vxe-table/lib/style.css';
import './lsrm/utils/monitor.js';

linkRedirect();

microApp.start({ // 兼容旧版microapp 版本小于1.0
    'disable-memory-router': true, // 关闭虚拟路由系统
    'disable-patch-request': true // 关闭对子应用请求的拦截
});

Vue.prototype.$echarts = echarts;

Vue.use(BaiduMap, {
    ak: '6N54N3ujNCfK9bKovNfqRcOnCHuoBoX7'
});
Vue.use(VXETable);

const moduleName = 'C-LSRM';
const childModuleName = '供应商平台';
bigDataLog.init(moduleName, childModuleName);

const whiteList = [];

checkLogin(router, whiteList);

store.dispatch('UPDATE_LANG').then(i18n => {
    Vue.use(ElementUI, {
        i18n: (path, options) => {
            const value = i18n.t(path, options);
            if (value) return value;
            return '';
        }
    });
    new Vue({
        router,
        store,
        i18n,
        mixins: [utils.IE11RouterFix()],
        render: h => h(App)
    }).$mount('#app');
});

// 大数据埋点-应用功能明细
document.body.addEventListener('click', function (ev) {
    let target = ev.target;
    while (target.tagName.toLowerCase() !== 'body') {
        if (!target.className) {
            target = target.parentNode;
            if (!target) {
                break;
            } else {
                continue;
            }
        }
        if (target.className && target.className.indexOf('bigData-btn-') < 0) {
            target = target.parentNode;
            // 无父级target时即停止循环，防止报错
            if (!target) {
                break;
            }
        } else {
            const params = {};
            const key = target.className.split(' ').find(li => li.indexOf('bigData-btn-') >= 0);
            let names = window.bigDataConfig[key];
            if (!names) {
                break;
            }
            if (typeof names === 'string') {
                names = names.split(',');
            }
            names.forEach((name, index) => {
                params['model_name' + (index + 1)] = name;
            });
            bigDataLog.sendDetailMessage(params);
            break;
        }
    }
});
